export const environment: string = globalThis.environment || 'prod';
export const deployment: string = globalThis.deployment || null;
export const devServer: boolean = globalThis.devServer || false;
